var map = {
	"./WhatsApp Image 2024-03-21 at 14.52.52 (1).jpeg": 7088,
	"./WhatsApp Image 2024-03-21 at 14.52.52 (2).jpeg": 2152,
	"./WhatsApp Image 2024-03-21 at 14.52.52 (3).jpeg": 4224,
	"./WhatsApp Image 2024-03-21 at 14.52.52.jpeg": 2736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6160;